/**
 * useMenuLayouts — lista layoutów tenanta (ADR-0031 Etap B).
 *
 * GET /api/menu/layouts zwraca metadata bez `hierarchy` (oszczędność na
 * dropdown). Pełny layout dociąga się przez `useMenuLayoutById(id)` przy
 * switch w buildera.
 */

import type { MenuLayoutSummary } from '@saas/shared';
import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';

export const MENU_LAYOUTS_QUERY_KEY = ['tenant', 'menu', 'layouts', 'list'] as const;

export interface MenuLayoutsResponse {
  layouts: MenuLayoutSummary[];
}

export function useMenuLayouts(opts?: { enabled?: boolean }) {
  return useQuery<MenuLayoutsResponse>({
    queryKey: MENU_LAYOUTS_QUERY_KEY,
    queryFn: async () => {
      const res = await api.get<MenuLayoutsResponse>('/menu/layouts');
      return res.data;
    },
    enabled: opts?.enabled ?? true,
    staleTime: 30_000,
  });
}
